import { useParams } from "react-router-dom";
import React from "react";
import WHOutContainer from '../../../../containers/Print/default/Warehouse-Out'
export const PrintWHOut = (props)=>{
    let params=useParams();
    let id=params.id;
    document.getElementById("root").setAttribute("style","overflow:hidden");
    return (
        <WHOutContainer id={id}/>
    )
}

export default PrintWHOut;